<template>
  <div class="error-container">
    <h1 class="error-code">
      <i class="ion ion-md-lock" style="margin-bottom: 1rem;"></i><br />
      Workspace Deactivated
    </h1>
    <p class="error-info">
      Your Floor Plan Mapper workspace is temporarily deactivated.<br />
      Please contact support at <a href="mailto:support@floorplanmapper.com">support@floorplanmapper.com</a> to reactivate your Floor Plan Mapper Workspace.
    </p>
  </div>
</template>

<script>
export default {
  name: 'AppLocked'
}
</script>

<style scoped>
.error-container {
  padding: 15vh 0 0 0;
  text-align: center;
}

.error-code {
  font-size: 4rem;
  margin-bottom: 3rem;
}

.error-info {
  font-size: 1.5rem;
}
</style>
